import Axios from "axios";
let baseURL = '/activity-api'
export default {
  get(url, obj) {
    return Axios.get(baseURL + url, { params: { ...obj }});
  },
  post(url, obj) {
    return Axios.post(baseURL + url, { ...obj });
  },
  put(url) {
    return Axios.put(baseURL + url);
  },
  delete(url) {
    return Axios.delete(baseURL + url);
  }
}
